import script from "./BenefitsList.vue?vue&type=script&setup=true&lang=js"
export * from "./BenefitsList.vue?vue&type=script&setup=true&lang=js"

import "./BenefitsList.vue?vue&type=style&index=0&id=3a298701&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3a298701"]])

export default __exports__